export default __webpack_public_path__ + "static/media/983.42182057.png";